import { Button, Checkbox, Col, Form, Modal, Row, Spin, Input, InputNumber } from 'antd';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import BreadCrumbs from '../../../../common/components/Breadcrumbs';
import { validateMessages } from '../../../../common/constants/common';
import { Page } from '../../../../common/constants/pageAction';
import { getObjectForUpdateMultiple } from '../../../../common/helperFunction';
import { IConfigSoftwareFamily } from '../../../../services/master/configSoftwareFamily/configSoftwareFamily.model';
import { useAppSelector, useAppDispatch } from '../../../../store/app.hooks';
import { updateMultiple } from '../../../../store/common/common.action';
import {
  clearMultipleUpdateMessages,
  commonSelector,
} from '../../../../store/common/common.reducer';
import {
  getConfigSoftwareFamilyById,
  saveConfigSoftwareFamily,
} from '../../../../store/master/configSoftwareFamily/configSoftwareFamily.action';
import {
  clearConfigSoftwareFamilyGetById,
  clearConfigSoftwareFamilyMessages,
  configSoftwareFamilySelector,
} from '../../../../store/master/configSoftwareFamily/configSoftwareFamily.reducer';
import { IAddConfigSoftwareFamilyProps } from './addConfigSoftwareFamily.model';
import _ from 'lodash';

const AddConfigSoftwareFamilyModal: React.FC<IAddConfigSoftwareFamilyProps> = (props) => {
  const configSoftwareFamily = useAppSelector(configSoftwareFamilySelector);
  const common = useAppSelector(commonSelector);
  const dispatch = useAppDispatch();
  const { id, showModal, handleModalClose, refreshDataTable, isMultiple, valuesForSelection } =
    props;

  const isNew: boolean = id || isMultiple ? false : true;
  const title = useMemo(() => {
    return (
      <>
        {isNew ? 'Add ' : 'Edit '} <BreadCrumbs pageName={Page.ConfigSoftwareFamily} level={1} />
      </>
    );
  }, [isNew]);
  const submitButtonText = useMemo(() => {
    return isNew ? 'Save' : 'Update';
  }, [isNew]);

  const [form] = Form.useForm();

  let initialValues: IConfigSoftwareFamily = {
    family: '',
    family_index: null,
  };

  const onFinish = (values: any) => {
    const inputValues: IConfigSoftwareFamily = {
      ...values,
      id: id ? +id : null,
    };
    if (!isMultiple) {
      dispatch(saveConfigSoftwareFamily(inputValues));
    } else {
      const result = getObjectForUpdateMultiple(
        valuesForSelection,
        inputValues,
        configSoftwareFamily.search.tableName
      );
      if (result) {
        dispatch(updateMultiple(result));
      }
    }
  };

  const fillValuesOnEdit = async (data: IConfigSoftwareFamily) => {
    if (data) {
      initialValues = {
        family: data.family,
        family_index: _.isNull(data.family_index) ? null : data.family_index,
      };
      form.setFieldsValue(initialValues);
    }
  };

  useEffect(() => {
    if (configSoftwareFamily.save.messages.length > 0) {
      if (configSoftwareFamily.save.hasErrors) {
        toast.error(configSoftwareFamily.save.messages.join(' '));
      } else {
        toast.success(configSoftwareFamily.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearConfigSoftwareFamilyMessages());
    }
  }, [configSoftwareFamily.save.messages]);

  useEffect(() => {
    if (common.save.messages.length > 0) {
      if (common.save.hasErrors) {
        toast.error(common.save.messages.join(' '));
      } else {
        toast.warn(common.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearMultipleUpdateMessages());
    }
  }, [common.save.messages]);

  useEffect(() => {
    if (+id > 0 && configSoftwareFamily.getById.data) {
      const data = configSoftwareFamily.getById.data;
      fillValuesOnEdit(data);
    }
  }, [configSoftwareFamily.getById.data]);

  useEffect(() => {
    if (+id > 0) {
      dispatch(getConfigSoftwareFamilyById(+id));
    }
    return () => {
      dispatch(clearConfigSoftwareFamilyGetById());
    };
  }, [dispatch]);

  return (
    <>
      <Modal
        wrapClassName="custom-modal"
        title={title}
        centered
        visible={showModal}
        onCancel={handleModalClose}
        footer={false}
      >
        {configSoftwareFamily.getById.loading ? (
          <div className="spin-loader">
            <Spin spinning={configSoftwareFamily.getById.loading} />
          </div>
        ) : (
          <Form
            form={form}
            name="configSoftwareFamily"
            initialValues={initialValues}
            onFinish={onFinish}
            validateMessages={validateMessages}
          >
            <Row gutter={[30, 15]} className="form-label-hide">
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'family']} valuePropName="checked" noStyle>
                      <Checkbox>Family</Checkbox>
                    </Form.Item>
                  ) : (
                    'Family'
                  )}
                  <Form.Item
                    name="family"
                    label="Family"
                    className="m-0"
                    rules={[{ required: !isMultiple, max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'family_index']} valuePropName="checked" noStyle>
                      <Checkbox>Family Index</Checkbox>
                    </Form.Item>
                  ) : (
                    'Family Index'
                  )}
                  <Form.Item
                    name="family_index"
                    label="Family Index"
                    className="m-0"
                    rules={[{ type: 'integer' }]}
                  >
                    <InputNumber className="form-control w-100" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <div className="btns-block modal-footer">
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={configSoftwareFamily.save.loading || common.save.loading}
              >
                {submitButtonText}
              </Button>
              <Button key="back" onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </>
  );
};
export default AddConfigSoftwareFamilyModal;
